import { ApolloClient as t, ApolloLink as r, HttpLink as m, InMemoryCache as l } from "@apollo/client";
import n from "../../../auth-lib/constants/config.js";
import { SHARE_OPERATIONS_WITH_AUTH as a } from "../../constants/graphql.js";
import { fetchWithAuth as p } from "../helper/authFetch.js";
const A = new t({
  link: new r(
    (o) => new m({
      uri: n.sso.domain.api,
      fetch: (e, i) => a.includes(o.operationName) ? p(e, i || {}, {
        loginDomain: n.sso.domain.api,
        graphql: !0
      }) : fetch(e, i)
    }).request(o)
  ),
  cache: new l()
});
export {
  A as default
};
//# sourceMappingURL=loginClient.js.map
